import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./InterventiActions";
import { InterventoDto } from "../generated";

class InterventiStore extends AbstractLookupStore<InterventoDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getByCustomer, ({ idCliente, interventi }) => this.set(idCliente.toString(), interventi))
            .onfunction(Actions.delete, ({ idCliente, idIntervento, deleteOk: result }) => {
                if (result)
                    this.deleteOne(idCliente?.toString() ?? "", idIntervento.toString(), x => x.idIntervento.toString())
            })
            .onfunction(Actions.update, intervento => {
                this.updateOne(intervento.idCliente?.toString() ?? "", intervento, x => x.idIntervento.toString())
            })
            .onfunction(Actions.add, intervento => {
                this.addOne(intervento.idCliente?.toString() ?? "", intervento, x => x.idIntervento.toString())
            })
            ;
    }
    public useForCliente = (idCliente: number) => this.useStoreWithAction(
        idCliente.toString(),
        cliente => Actions.getByCustomer(+cliente),
        x => x.dataIntervento.valueOf()
    );
}


export default new InterventiStore()
